import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  Select,
  Flex,
  useToast,
  Icon,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Text,
} from "@chakra-ui/react";
import { useState, useEffect, useCallback, useRef } from "react";
import { FiUploadCloud, FiPlusCircle } from "react-icons/fi";

import OptionsService from "./OptionsOsService";
import CompanyAddressService from "../Enterprise/CompanyAddressService";
import {
  criarOrdemServico,
  buscarTodasUnidadesDisponiveis,
} from "./ServiceOrder.js";
import { extractTextFromPdf } from "./pdfReader";
import { useNavigate } from "react-router-dom";
import {
  convertDateToInputFormat,
  formatToISOString,
  normalizeDateTimeLocal,
} from "./osDateUtils";
import ModernPageShell from "../../components/layout/ModernPageShell";
import { getModernUi } from "../../components/layout/modernUi";

export default function CriarOS({ modern = false }) {
  const ui = getModernUi(modern);
  const toast = useToast();
  const fileInputRef = useRef(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isNewServiceTypeModalOpen,
    onOpen: onNewServiceTypeModalOpen,
    onClose: onNewServiceTypeModalClose,
  } = useDisclosure();
  const {
    isOpen: isNewTeamTypeModal,
    onOpen: onNewTeamTypeModalOpen,
    onClose: onNewTeamTypeModalClose,
  } = useDisclosure();
  const {
    isOpen: isNewPriorityModalOpen,
    onOpen: onNewPriorityModalOpen,
    onClose: onNewPriorityModalClose,
  } = useDisclosure();
  const {
    isOpen: isNewStatusModalOpen,
    onOpen: onNewStatusModalOpen,
    onClose: onNewStatusModalClose,
  } = useDisclosure();

  const [pdfFile, setPdfFile] = useState(null);
  const [pdfName, setPdfName] = useState("");
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [pdfContentText, setPdfContentText] = useState("");

  const [prioridades, setPrioridades] = useState([]);
  const [status, setStatus] = useState([]);
  const [tiposServico, setTiposServico] = useState([]);
  const [tiposEquipe, setTiposEquipe] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(true);

  const [availableUnits, setAvailableUnits] = useState([]);
  const [loadingUnits, setLoadingUnits] = useState(true);
  const [errorUnits, setErrorUnits] = useState(null);

  const [empresasOptions, setEmpresasOptions] = useState([]);
  const [loadingEmpresas, setLoadingEmpresas] = useState(true);
  const [errorEmpresas, setErrorEmpresas] = useState(null);

  const [newServiceTypeName, setNewServiceTypeName] = useState("");
  const [tempPdfServiceTypeNotFound, setTempPdfServiceTypeNotFound] =
    useState("");

  const [newTeamTypeName, setNewTeamTypeName] = useState("");
  const [tempPdfTeamTypeNotFound, setTempPdfTeamTypeNotFound] = useState("");

  const [newPriorityName, setNewPriorityName] = useState("");
  const [tempPdfPriorityNotFound, setTempPdfPriorityNotFound] = useState("");

  const [newStatusName, setNewStatusName] = useState("");
  const [tempPdfStatusNotFound, setTempPdfStatusNotFound] = useState("");

  const [novaFilialForm, setNovaFilialForm] = useState({
    empresaId: "",
    unityName: "",
    additionalAddressDetails: "",
  });

  const [tempPdfUnitNotFound, setTempPdfUnitNotFound] = useState("");

  const [orderNumber, setOrderNumber] = useState("");

  const [requesterName, setRequesterName] = useState("");
  const [requestClientPhone, setRequestClientPhone] = useState("");
  const [requestClientMail, setRequestClientMail] = useState("");

  const [recipientClientName, setRecipientClientName] = useState("");
  const [recipientClientPhone, setRecipientClientPhone] = useState("");
  const [recipientClientMail, setRecipientClientMail] = useState("");

  const [tecnicoResponsavel, setTecnicoResponsavel] = useState("");
  const [equipeResponsavel, setEquipeResponsavel] = useState("");
  const [teamId, setTeamId] = useState("");

  const [priorityId, setPriorityId] = useState("");
  const [statusId, setStatusId] = useState("");
  const [tipoServicoSelecionado, setTipoServicoSelecionado] = useState("");
  const [tipoServicoDescricao, setTipoServicoDescricao] = useState("");
  const [addressDetails, setAddressDetails] = useState("");
  const [addressDetails2, setAddressDetails2] = useState("");
  const [floor, setFloor] = useState("");

  const [dateRequest, setDateRequest] = useState("");
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [dateExpected, setDateExpected] = useState("");

  const [endereco, setEndereco] = useState("");
  const [unidade, setUnidade] = useState("");
  const [andar, setAndar] = useState("");
  const [complemento1, setComplemento1] = useState("");
  const [complemento2, setComplemento2] = useState("");

  const [details, setDetails] = useState("");
  const [summary, setSummary] = useState("");

  const loadServiceTypes = useCallback(async () => {
    try {
      const tiposServicoData = await OptionsService.getOptionsByType(
        "typeofservice"
      );
      setTiposServico(Array.isArray(tiposServicoData) ? tiposServicoData : []);
    } catch (error) {
      toast({
        title: "Erro ao carregar tipos de serviço",
        description: "Não foi possível carregar as opções de tipo de serviço.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [toast]);

  const loadPriorities = useCallback(async () => {
    try {
      const prioridadesData = await OptionsService.getOptionsByType("priority");
      setPrioridades(Array.isArray(prioridadesData) ? prioridadesData : []);
    } catch (error) {
      toast({
        title: "Erro ao carregar prioridades",
        description: "Não foi possível carregar as opções de prioridade.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [toast]);

  const loadStatus = useCallback(async () => {
    try {
      const statusData = await OptionsService.getOptionsByType(
        "statusofservice"
      );
      setStatus(Array.isArray(statusData) ? statusData : []);
    } catch (error) {
      toast({
        title: "Erro ao carregar status",
        description: "Não foi possível carregar as opções de status.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [toast]);

  const loadTeamTypes = useCallback(async () => {
    try {
      const tiposEquipeData = await OptionsService.getOptionsByType("team");
      setTiposEquipe(Array.isArray(tiposEquipeData) ? tiposEquipeData : []);
    } catch (error) {
      toast({
        title: "Erro ao carregar tipos de equipe",
        description: "Não foi possível carregar as opções de tipo de equipe.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [toast]);

  const loadUnits = useCallback(async () => {
    try {
      setLoadingUnits(true);
      const units = await buscarTodasUnidadesDisponiveis();
      setAvailableUnits(units);
      setErrorUnits(null);
    } catch (error) {
      setErrorUnits(error.message || "Erro desconhecido ao carregar unidades.");
      toast({
        title: "Erro ao carregar unidades",
        description:
          "Não foi possível carregar as opções de unidade/endereço. Verifique o console.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoadingUnits(false);
    }
  }, [toast]);

  useEffect(() => {}, [andar]);

  useEffect(() => {
    async function fetchAllOptions() {
      setLoadingOptions(true);
      await Promise.all([
        loadPriorities(),
        loadStatus(),
        loadServiceTypes(),
        loadTeamTypes(),
      ]);
      setLoadingOptions(false);
    }
    fetchAllOptions();
  }, [loadPriorities, loadStatus, loadServiceTypes, loadTeamTypes]);

  useEffect(() => {
    loadUnits();
  }, [loadUnits]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setLoadingEmpresas(true);
        setErrorEmpresas(null);
        const data = await OptionsService.getOptionsByType("Company");
        setEmpresasOptions(data);
      } catch (err) {
        setErrorEmpresas(
          err.message || "Não foi possível carregar as empresas."
        );
      } finally {
        setLoadingEmpresas(false);
      }
    };
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (tipoServicoSelecionado && tiposServico.length > 0) {
      const selectedOption = tiposServico.find(
        (opt) => opt.optionsId === tipoServicoSelecionado
      );
      if (selectedOption) {
        setTipoServicoDescricao(selectedOption.description);
      }
    } else {
      setTipoServicoDescricao("");
    }
  }, [tipoServicoSelecionado, tiposServico]);

  const handleUnitSelect = useCallback(
    (e) => {
      const selectedUnitId = e.target.value;
      setUnidade(selectedUnitId);

      setTempPdfUnitNotFound("");

      if (selectedUnitId) {
        const unit = availableUnits.find(
          (u) => String(u.companyAddressId) === selectedUnitId
        );
        if (unit) {
        }
      } else {
      }
    },
    [availableUnits]
  );
  const parsePdfContent = useCallback(
    (text) => {
      const lines = text
        .split("\n")
        .map((line) => line.replace(/\xA0/g, " ").trim())
        .filter((line) => line.length > 0);

      // Limpa todos os estados antes de começar a preencher
      setRequesterName("");
      setRequestClientPhone("");
      setRequestClientMail("");
      setRecipientClientName("");
      setRecipientClientPhone("");
      setRecipientClientMail("");
      setTecnicoResponsavel("");
      setEquipeResponsavel("");
      setTeamId("");
      setPriorityId("");
      setStatusId("");
      setTipoServicoSelecionado("");
      setTipoServicoDescricao("");
      setDateRequest("");
      setDateStart("");
      setDateEnd("");
      setDateExpected("");
      setUnidade("");
      setEndereco("");
      setAndar("");
      setComplemento1("");
      setComplemento2("");
      setDetails("");
      setSummary("");
      setOrderNumber("");

      setTempPdfServiceTypeNotFound("");
      setTempPdfTeamTypeNotFound("");
      setTempPdfPriorityNotFound("");
      setTempPdfStatusNotFound("");
      setTempPdfUnitNotFound("");

      const extractValue = (line, label) => {
        const escapedLabel = label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        const match = line.match(
          new RegExp(`${escapedLabel}\\s*:(?:\\s|\\xA0)*(.*)`, "i") //
        );
        if (match) {
          return match[1].trim().replace(/"/g, "");
        }
        return null;
      };

      let foundUnitNameFromPdf = "";

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];

        const orderNumberMatch = line.match(
          /(?:Chamado\s*#*#*|Chamado\s*:\s*)(\d+)/i
        );
        if (orderNumberMatch && orderNumberMatch[1]) {
          setOrderNumber(orderNumberMatch[1].trim());
        }

        if (line.includes("Nome do solicitante:")) {
          const value = extractValue(line, "Nome do solicitante");
          if (value) setRequesterName(value);
        } else if (line.includes("Telefone do solicitante:")) {
          const value = extractValue(line, "Telefone do solicitante");
          if (value) setRequestClientPhone(value);
        } else if (line.includes("E-mail do solicitante:")) {
          const value = extractValue(line, "E-mail do solicitante");
          if (value) setRequestClientMail(value);
        } else if (line.includes("Endereço:")) {
          const value = extractValue(line, "Endereço");
          if (value) setEndereco(value);
        }

        // Logs e parsing para Andar, Complemento 1 e Complemento 2
        if (line.includes("Andar:")) {
          const value = extractValue(line, "Andar");

          if (value) {
            setAndar(value);
          } else {
          }
        }
        if (line.includes("Complemento") && line.includes(":")) {
          const value = extractValue(line, "Complemento");

          if (value) {
            setComplemento1(value);
          } else {
          }
        }
        if (line.includes("Complemento 2:")) {
          const value = extractValue(line, "Complemento 2");

          if (value) {
            setComplemento2(value);
          } else {
          }
        }
        // FIM DOS LOGS E PARSING ESPECÍFICOS

        const solicitedForBlockStart = line.includes("Solicitado Para:");
        if (solicitedForBlockStart) {
          for (let j = i + 1; j < Math.min(lines.length, i + 5); j++) {
            const subLine = lines[j];
            if (subLine.includes("Nome:")) {
              const value = extractValue(subLine, "Nome");
              if (value) setRecipientClientName(value);
            } else if (subLine.includes("Telefone:")) {
              const value = extractValue(subLine, "Telefone");
              if (value) setRecipientClientPhone(value);
            } else if (subLine.includes("E-mail:")) {
              const value = extractValue(subLine, "E-mail");
              if (value) setRecipientClientMail(value);
            }
            if (
              subLine.includes("Detalhes da Solicitação") ||
              subLine.includes("Endereço:")
            ) {
              break;
            }
          }
        }

        if (line.includes("Prioridade:")) {
          const value = extractValue(line, "Prioridade");
          if (value) {
            const matchedPriority = prioridades.find(
              (p) => p.description.toLowerCase() === value.toLowerCase()
            );
            if (matchedPriority) {
              setPriorityId(matchedPriority.optionsId);
              setTempPdfPriorityNotFound("");
            } else {
              setPriorityId("");
              setTempPdfPriorityNotFound(value);
              toast({
                title: "Atenção!",
                description: `A Prioridade "${value}" do PDF não encontrada. Você pode adicioná-la.`,
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            }
          }
        } else if (line.includes("Tipo Equipe:")) {
          const value = extractValue(line, "Tipo Equipe");
          if (value) {
            const matchedTeam = tiposEquipe.find(
              (t) => t.description.toLowerCase() === value.toLowerCase()
            );
            if (matchedTeam) {
              setTeamId(matchedTeam.optionsId);
              setTempPdfTeamTypeNotFound("");
            } else {
              setTeamId("");
              setTempPdfTeamTypeNotFound(value);
              toast({
                title: "Atenção!",
                description: `O Tipo de Equipe "${value}" do PDF não encontrado. Você pode adicioná-lo.`,
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            }
          }
        } else if (line.includes("Status:")) {
          const value = extractValue(line, "Status");
          if (value) {
            const matchedStatus = status.find(
              (s) => s.description.toLowerCase() === value.toLowerCase()
            );
            if (matchedStatus) {
              setStatusId(matchedStatus.optionsId);
              setTempPdfStatusNotFound("");
            } else {
              setStatusId("");
              setTempPdfStatusNotFound(value);
              toast({
                title: "Atenção!",
                description: `O Status "${value}" do PDF não encontrado. Você pode adicioná-lo.`,
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            }
          }
        } else if (line.includes("Resumo:")) {
          const value = extractValue(line, "Resumo");
          if (value) {
            const matchedServiceType = tiposServico.find(
              (serviceType) =>
                serviceType.description.toLowerCase() === value.toLowerCase()
            );

            if (matchedServiceType) {
              setTipoServicoSelecionado(matchedServiceType.optionsId);
              setTipoServicoDescricao(matchedServiceType.description);
              setTempPdfServiceTypeNotFound("");
            } else {
              setTipoServicoSelecionado("");
              setTipoServicoDescricao(value);
              setTempPdfServiceTypeNotFound(value);
              toast({
                title: "Atenção!",
                description: `O "Resumo" do PDF ("${value}") não correspondeu a um Tipo de Serviço existente. Você pode adicioná-lo.`,
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            }
          }
        } else if (line.includes("Detalhes:")) {
          let detailContent = extractValue(line, "Detalhes");
          let nextLineIndex = i + 1;
          while (
            nextLineIndex < lines.length &&
            !lines[nextLineIndex].includes("Endereço:") &&
            !lines[nextLineIndex].includes("Informações complementares:") &&
            !lines[nextLineIndex].includes("Datas:") &&
            !lines[nextLineIndex].includes("Prioridade:") &&
            !lines[nextLineIndex].includes("Unidade:") &&
            lines[nextLineIndex].trim().length > 0
          ) {
            detailContent += " " + lines[nextLineIndex].trim();
            nextLineIndex++;
          }
          if (detailContent) setDetails(detailContent);
        }

        if (line.includes("Unidade:")) {
          foundUnitNameFromPdf = extractValue(line, "Unidade");
          if (foundUnitNameFromPdf) {
            const matchedUnit = availableUnits.find(
              (unit) =>
                (unit.unityName || "").toLowerCase() ===
                foundUnitNameFromPdf.toLowerCase()
            );

            if (matchedUnit) {
              setUnidade(matchedUnit.companyAddressId);
              setTempPdfUnitNotFound("");
            } else {
              setUnidade("");
              setEndereco("");
              setTempPdfUnitNotFound(foundUnitNameFromPdf);
              toast({
                title: "Unidade não encontrada!",
                description: `A Unidade "${foundUnitNameFromPdf}" encontrada no PDF não existe na sua lista. Você pode adicioná-la.`,
                status: "warning",
                duration: 7000,
                isClosable: true,
              });
            }
          } else {
            setUnidade("");
            setEndereco("");
            setTempPdfUnitNotFound("Não extraído (verificar formato do PDF)");
            toast({
              title: "Atenção na extração da Unidade!",
              description: `A linha "Unidade:" foi encontrada, mas o nome da unidade não pôde ser extraído. Verifique o formato do PDF.`,
              status: "warning",
              duration: 7000,
            });
          }
        }
        if (line.includes("Data da Abertura:")) {
          const value = extractValue(line, "Data da Abertura");
          if (value) {
            setDateRequest(convertDateToInputFormat(value));
          }
        }
        if (line.includes("Início Efetivo:")) {
          const value = extractValue(line, "Início Efetivo");
          if (value) {
            setDateStart(convertDateToInputFormat(value));
          }
        }
        if (line.includes("Término Previsto (SLA):")) {
          const value = extractValue(line, "Término Previsto (SLA)");
          if (value) {
            setDateEnd(convertDateToInputFormat(value));
          }
        }
        if (line.includes("Data de Término Esperado:")) {
          const value = extractValue(line, "Data de Término Esperado");
          if (value) {
            setDateExpected(convertDateToInputFormat(value));
          }
        }
      }

      toast({
        title: "PDF processado.",
        description: "Os campos foram preenchidos com base no conteúdo do PDF.",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
    },
    [prioridades, tiposServico, tiposEquipe, status, availableUnits, toast]
  );
  useEffect(() => {
    if (unidade) {
      handleUnitSelect({ target: { value: unidade } });
    } else {
      setEndereco("");

      setComplemento1("");
    }
  }, [unidade, handleUnitSelect]);

  const handleUploadPDF = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
      setPdfName(file.name);
      setLoadingPdf(true);

      try {
        let attempts = 0;
        const maxAttempts = 30;
        while ((loadingOptions || loadingUnits) && attempts < maxAttempts) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          attempts++;
        }

        if (attempts === maxAttempts && (loadingOptions || loadingUnits)) {
          toast({
            title: "Erro de Carregamento",
            description:
              "As opções e unidades demoraram muito para carregar. Tente novamente.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
          setLoadingPdf(false);
          return;
        }

        const text = await extractTextFromPdf(file);
        setPdfContentText(text);
        parsePdfContent(text);
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : String(error);

        toast({
          title: "Erro ao ler PDF.",
          description:
            errorMessage ||
            "Não foi possível extrair o texto do PDF. Verifique o console para mais detalhes.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        setPdfFile(null);
        setPdfName("");
      } finally {
        setLoadingPdf(false);
      }
    } else {
      setPdfFile(null);
      setPdfName("");
      toast({
        title: "Arquivo inválido.",
        description: `Por favor, selecione um arquivo PDF.`,
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const SectionTitle = ({ children }) => (
    <Heading
      size="md"
      mt={modern ? 8 : 10}
      mb={modern ? 4 : 4}
      color={modern ? "gray.700" : "#C1272D"}
      borderBottom={modern ? "none" : "2px solid #625752"}
      pb={modern ? 0 : 1}
      fontWeight={modern ? "semibold" : "bold"}
    >
      {children}
    </Heading>
  );

  const inputStyles = modern
    ? ui.input
    : {
        bg: "white",
        borderColor: "#625752",
        focusBorderColor: "#C1272D",
      };

  const handleChangeNovaFilial = (e) => {
    const { name, value } = e.target;
    setNovaFilialForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitNovaFilial = async () => {
    // if (
    //   !novaFilialForm.empresaId ||
    //   !novaFilialForm.unityName ||
    //   !novaFilialForm.additionalAddressDetails
    // ) {
    //   toast({
    //     title: "Preencha todos os campos obrigatórios da filial.",
    //     status: "error",
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   return;
    // }

    try {
      const companyAddressData = {
        unityName: novaFilialForm.unityName,
        additionalAddressDetails: novaFilialForm.additionalAddressDetails,
        company: {
          optionsId: novaFilialForm.empresaId,
        },
      };

      const createdCompanyAddress =
        await CompanyAddressService.createCompanyAddress(companyAddressData);

      toast({
        title: "Filial cadastrada com sucesso!",
        description: `Filial: ${createdCompanyAddress.unityName}, ID: ${createdCompanyAddress.companyAddressId}`,
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setNovaFilialForm({
        empresaId: "",
        unityName: "",
        additionalAddressDetails: "",
      });

      await loadUnits();

      setTempPdfUnitNotFound("");
      onClose();

      if (pdfContentText) {
        parsePdfContent(pdfContentText);
      } else {
        toast({
          title: "Aviso",
          description:
            "PDF não pode ser re-processado automaticamente (texto não disponível). Por favor, recarregue o PDF.",
          status: "info",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Erro ao cadastrar filial.",
        description:
          error.response?.data?.message ||
          "Ocorreu um erro desconhecido. Tente novamente mais tarde.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleAddServiceType = async () => {
    if (!newServiceTypeName.trim()) {
      toast({
        title: "Nome do Tipo de Serviço vazio.",
        description: "Por favor, insira um nome para o novo tipo de serviço.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const newOptionData = {
        description: newServiceTypeName.trim(),
        type: "typeofservice",
      };

      const createdOption = await OptionsService.createOption(newOptionData);
      toast({
        title: "Tipo de Serviço adicionado!",
        description: `'${createdOption.description}' foi adicionado aos tipos de serviço.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      await loadServiceTypes();
      setTipoServicoSelecionado(createdOption.optionsId);
      setTipoServicoDescricao(createdOption.description);
      setNewServiceTypeName("");
      setTempPdfServiceTypeNotFound("");
      onNewServiceTypeModalClose();
    } catch (error) {
      toast({
        title: "Erro ao adicionar Tipo de Serviço.",
        description:
          error.response?.data?.message ||
          "Não foi possível adicionar o tipo de serviço. Verifique o console.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleAddTeamType = async () => {
    if (!newTeamTypeName.trim()) {
      toast({
        title: "Nome do Tipo de Equipe vazio.",
        description: "Por favor, insira um nome para o novo tipo de equipe.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const newOptionData = {
        description: newTeamTypeName.trim(),
        type: "team",
      };

      const createdOption = await OptionsService.createOption(newOptionData);
      toast({
        title: "Tipo de Equipe adicionado!",
        description: `'${createdOption.description}' foi adicionado aos tipos de equipe.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      await loadTeamTypes();
      setTeamId(createdOption.optionsId);
      setNewTeamTypeName("");
      setTempPdfTeamTypeNotFound("");
      onNewTeamTypeModalClose();
    } catch (error) {
      toast({
        title: "Erro ao adicionar Tipo de Equipe.",
        description:
          error.response?.data?.message ||
          "Não foi possível adicionar o tipo de equipe. Verifique o console.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleAddPriority = async () => {
    if (!newPriorityName.trim()) {
      toast({
        title: "Nome da Prioridade vazio.",
        description: "Por favor, insira um nome para a nova prioridade.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const newOptionData = {
        description: newPriorityName.trim(),
        type: "priority",
      };

      const createdOption = await OptionsService.createOption(newOptionData);
      toast({
        title: "Prioridade adicionada!",
        description: `'${createdOption.description}' foi adicionada às prioridades.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      await loadPriorities();
      setPriorityId(createdOption.optionsId);
      setNewPriorityName("");
      setTempPdfPriorityNotFound("");
      onNewPriorityModalClose();
    } catch (error) {
      toast({
        title: "Erro ao adicionar Prioridade.",
        description:
          error.response?.data?.message ||
          "Não foi possível adicionar a prioridade. Verifique o console.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleAddStatus = async () => {
    if (!newStatusName.trim()) {
      toast({
        title: "Nome do Status vazio.",
        description: "Por favor, insira um nome para o novo status.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const newOptionData = {
        description: newStatusName.trim(),
        type: "statusofservice",
      };

      const createdOption = await OptionsService.createOption(newOptionData);
      toast({
        title: "Status adicionado!",
        description: `'${createdOption.description}' foi adicionado aos status.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      await loadStatus();
      setStatusId(createdOption.optionsId);
      setNewStatusName("");
      setTempPdfStatusNotFound("");
      onNewStatusModalClose();
    } catch (error) {
      toast({
        title: "Erro ao adicionar Status.",
        description:
          error.response?.data?.message ||
          "Não foi possível adicionar o status. Verifique o console.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleSubmit = async () => {
    const missingFields = [];
    if (orderNumber === "") missingFields.push("Ordem de Serviço");
    if (!requesterName) missingFields.push("Nome do Solicitante");
    if (!teamId) missingFields.push("Tipo de Equipe");
    if (!priorityId) missingFields.push("Prioridade");
    if (!statusId) missingFields.push("Status");
    if (!tipoServicoSelecionado) missingFields.push("Tipo de Serviço");
    if (!dateRequest) missingFields.push("Data de Abertura");
    if (!dateStart) missingFields.push("Início Efetivo");
    if (!dateEnd) missingFields.push("Término Previsto (SLA)");
    if (!dateExpected) missingFields.push("Data de Término Esperado");
    if (!unidade) missingFields.push("Unidade");
    if (!details?.trim()) missingFields.push("Detalhes Completos");

    if (missingFields.length > 0) {
      toast({
        title: "Campos obrigatórios faltando.",
        description: `Preencha: ${missingFields.join(", ")}.`,
        status: "error",
        duration: 7000,
        isClosable: true,
      });
      return;
    }

    const normalizedDates = {
      dateRequest: formatToISOString(dateRequest),
      dateStart: formatToISOString(dateStart),
      dateEnd: formatToISOString(dateEnd),
      dateExpected: formatToISOString(dateExpected),
    };

    const invalidDates = Object.entries(normalizedDates)
      .filter(([, value]) => !value)
      .map(([key]) =>
        ({
          dateRequest: "Data de Abertura",
          dateStart: "Início Efetivo",
          dateEnd: "Término Previsto (SLA)",
          dateExpected: "Data de Término Esperado",
        })[key]
      );

    if (invalidDates.length > 0) {
      toast({
        title: "Datas inválidas.",
        description: `Corrija: ${invalidDates.join(", ")}. Use o formato correto (ano com 4 dígitos).`,
        status: "error",
        duration: 7000,
        isClosable: true,
      });
      return;
    }

    // Se o PDF trouxe ano corrompido (ex.: 20226), corrige os campos na tela
    const fixedRequest = normalizeDateTimeLocal(dateRequest);
    const fixedStart = normalizeDateTimeLocal(dateStart);
    const fixedEnd = normalizeDateTimeLocal(dateEnd);
    const fixedExpected = normalizeDateTimeLocal(dateExpected);
    if (fixedRequest && fixedRequest !== dateRequest) setDateRequest(fixedRequest);
    if (fixedStart && fixedStart !== dateStart) setDateStart(fixedStart);
    if (fixedEnd && fixedEnd !== dateEnd) setDateEnd(fixedEnd);
    if (fixedExpected && fixedExpected !== dateExpected) {
      setDateExpected(fixedExpected);
    }

    const osData = {
      orderNumber: Number(orderNumber),
      requesterName,
      requestClientPhone,
      requestClientMail,
      recipientClientName,
      recipientClientPhone,
      recipientClientMail,
      teamId: teamId,
      priorityId: priorityId,
      statusId: statusId,
      companyRequests: {
        optionsId: tipoServicoSelecionado,
        description: tipoServicoDescricao,
        type: "typeofservice",
      },
      dateRequest: normalizedDates.dateRequest,
      dateStart: normalizedDates.dateStart,
      dateEnd: normalizedDates.dateEnd,
      dateExpected: normalizedDates.dateExpected,
      companyAddressId: unidade,
      details,
      summary,
      situation: statusId,
      addressDetails: complemento1,
      addressDetails2: complemento2,
      floor: andar,
    };

    try {
      const response = await criarOrdemServico(osData);
      toast({
        title: "Ordem de Serviço criada!",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setOrderNumber("");
      setRequesterName("");
      setRequestClientPhone("");
      setRequestClientMail("");
      setRecipientClientName("");
      setRecipientClientPhone("");
      setRecipientClientMail("");
      setTecnicoResponsavel("");
      setEquipeResponsavel("");
      setTeamId("");
      setPriorityId("");
      setStatusId("");
      setTipoServicoSelecionado("");
      setTipoServicoDescricao("");
      setDateRequest("");
      setDateStart("");
      setDateEnd("");
      setDateExpected("");
      setUnidade("");
      setEndereco("");
      setAndar("");
      setComplemento1("");
      setComplemento2("");
      setDetails("");
      setSummary("");
      setPdfFile(null);
      setPdfName("");
      setPdfContentText("");

      setTempPdfServiceTypeNotFound("");
      setTempPdfTeamTypeNotFound("");
      setTempPdfPriorityNotFound("");
      setTempPdfStatusNotFound("");
      setTempPdfUnitNotFound("");
    } catch (error) {
      toast({
        title: "Erro ao criar OS.",
        description:
          error.response?.data?.message ||
          "Não foi possível criar a Ordem de Serviço. Verifique o console para mais detalhes.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const pageContent = (
    <>
      {!modern && (
        <Heading mb={6} color="#C1272D" fontSize="2xl" textAlign="center">
          📋 Criar Nova Ordem de Serviço
        </Heading>
      )}

      <Box
        {...(modern
          ? ui.card
          : {
              p: 6,
              borderWidth: "1px",
              borderRadius: "lg",
              bg: "white",
              boxShadow: "md",
            })}
        textAlign="center"
        mb={modern ? 2 : 0}
      >
        <Heading as="h2" size="md" mb={4} color="#625752">
          Upload de PDF do Chamado
        </Heading>
        <FormControl mb={4}>
          <FormLabel
            htmlFor="pdf-upload"
            cursor="pointer"
            p={4}
            border="2px dashed"
            borderColor={pdfFile ? "green.500" : "#625752"}
            borderRadius="md"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            _hover={{ borderColor: "#C1272D", bg: "gray.50" }}
            transition="all 0.2s ease-in-out"
          >
            {loadingPdf ? (
              <Flex alignItems="center" gap={2}>
                <Spinner size="sm" color="#C1272D" />
                <Text color="#625752">Processando PDF...</Text>
              </Flex>
            ) : pdfName ? (
              <Flex alignItems="center" gap={2} color="green.500">
                <Icon as={FiUploadCloud} boxSize={5} />
                <Text fontWeight="semibold">{pdfName}</Text>
                <Text fontSize="sm">(PDF carregado e processado)</Text>
              </Flex>
            ) : (
              <Flex alignItems="center" gap={2} color="#625752">
                <Icon as={FiUploadCloud} boxSize={6} />
                <Text fontWeight="semibold">Clique para selecionar um PDF</Text>
                <Text fontSize="sm">(ou arraste e solte aqui)</Text>
              </Flex>
            )}
            <Input
              id="pdf-upload"
              type="file"
              accept=".pdf"
              onChange={handleUploadPDF}
              display="none"
              ref={fileInputRef}
            />
          </FormLabel>
        </FormControl>
      </Box>

      <SectionTitle>Informações do Solicitante</SectionTitle>
      <Flex gap={4} mb={4} flexWrap="wrap">
        <FormControl
          flex="none"
          width={{ base: "100%", md: "250px" }}
          isRequired
        >
          <FormLabel>Ordem de Serviço (Chamado)</FormLabel>
          <Input
            placeholder="Ex: 123456"
            {...inputStyles}
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value)}
            type="number"
          />
        </FormControl>
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Nome do Solicitante</FormLabel>
          <Input
            placeholder="Nome completo do solicitante"
            {...inputStyles}
            value={requesterName}
            onChange={(e) => setRequesterName(e.target.value)}
          />
        </FormControl>
        <FormControl flex="1" minW="250px">
          <FormLabel>Telefone (Cliente Requisitante)</FormLabel>
          <Input
            placeholder="(11) 98765-4321"
            {...inputStyles}
            value={requestClientPhone}
            onChange={(e) => setRequestClientPhone(e.target.value)}
          />
        </FormControl>
        <FormControl flex="1" minW="250px">
          <FormLabel>Email (Cliente Requisitante)</FormLabel>
          <Input
            placeholder="email@exemplo.com"
            type="email"
            {...inputStyles}
            value={requestClientMail}
            onChange={(e) => setRequestClientMail(e.target.value)}
          />
        </FormControl>
      </Flex>

      <SectionTitle>Solicitado Para</SectionTitle>
      <Flex gap={4} mb={4} flexWrap="wrap">
        <FormControl flex="1" minW="250px">
          <FormLabel>Nome (Pessoa Solicitada)</FormLabel>
          <Input
            placeholder="Nome da pessoa que receberá o serviço"
            {...inputStyles}
            value={recipientClientName}
            onChange={(e) => setRecipientClientName(e.target.value)}
          />
        </FormControl>
        <FormControl flex="1" minW="250px">
          <FormLabel>Telefone (Pessoa Solicitada)</FormLabel>
          <Input
            placeholder="(11) 91234-5678"
            {...inputStyles}
            value={recipientClientPhone}
            onChange={(e) => setRecipientClientPhone(e.target.value)}
          />
        </FormControl>
        <FormControl flex="1" minW="250px">
          <FormLabel>Email (Pessoa Solicitada)</FormLabel>
          <Input
            placeholder="email@exemplo.com"
            type="email"
            {...inputStyles}
            value={recipientClientMail}
            onChange={(e) => setRecipientClientMail(e.target.value)}
          />
        </FormControl>
      </Flex>

      <SectionTitle>Equipe e Responsáveis</SectionTitle>
      <Flex gap={4} mb={4} flexWrap="wrap">
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Tipo de Equipe</FormLabel>
          <Select
            placeholder="Selecionar tipo"
            {...inputStyles}
            isDisabled={loadingOptions}
            value={teamId}
            onChange={(e) => {
              setTeamId(e.target.value);
              setTempPdfTeamTypeNotFound("");
            }}
          >
            {loadingOptions ? (
              <option>Carregando...</option>
            ) : (
              tiposEquipe
                .filter((opt) => opt)
                .map((opt) => (
                  <option key={opt.optionsId} value={opt.optionsId}>
                    {opt.description}
                  </option>
                ))
            )}
          </Select>
          {tempPdfTeamTypeNotFound && (
            <Flex mt={2} alignItems="center" justifyContent="space-between">
              <Text fontSize="sm" color="red.500">
                "{tempPdfTeamTypeNotFound}" (do PDF) não encontrado.
              </Text>
              <Button
                size="sm"
                colorScheme="blue"
                onClick={() => {
                  setNewTeamTypeName(tempPdfTeamTypeNotFound);
                  onNewTeamTypeModalOpen();
                }}
              >
                Adicionar como Novo Tipo
              </Button>
            </Flex>
          )}
        </FormControl>
      </Flex>

      <SectionTitle>Serviço</SectionTitle>
      <Flex gap={4} mb={4} flexWrap="wrap">
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Prioridade</FormLabel>
          <Select
            placeholder="Selecionar prioridade"
            {...inputStyles}
            isDisabled={loadingOptions}
            value={priorityId}
            onChange={(e) => {
              setPriorityId(e.target.value);
              setTempPdfPriorityNotFound("");
            }}
          >
            {loadingOptions ? (
              <option>Carregando...</option>
            ) : (
              prioridades
                .filter((opt) => opt)
                .map((opt) => (
                  <option key={opt.optionsId} value={opt.optionsId}>
                    {opt.description}
                  </option>
                ))
            )}
          </Select>
          {tempPdfPriorityNotFound && (
            <Flex mt={2} alignItems="center" justifyContent="space-between">
              <Text fontSize="sm" color="red.500">
                "{tempPdfPriorityNotFound}" (do PDF) não encontrado.
              </Text>
              <Button
                size="sm"
                colorScheme="blue"
                onClick={() => {
                  setNewPriorityName(tempPdfPriorityNotFound);
                  onNewPriorityModalOpen();
                }}
              >
                Adicionar como Nova Prioridade
              </Button>
            </Flex>
          )}
        </FormControl>
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Status</FormLabel>
          <Select
            placeholder="Selecionar status"
            {...inputStyles}
            isDisabled={loadingOptions}
            value={statusId}
            onChange={(e) => {
              setStatusId(e.target.value);
              setTempPdfStatusNotFound("");
            }}
          >
            {loadingOptions ? (
              <option>Carregando...</option>
            ) : (
              status
                .filter((opt) => opt)
                .map((opt) => (
                  <option key={opt.optionsId} value={opt.optionsId}>
                    {opt.description}
                  </option>
                ))
            )}
          </Select>
          {tempPdfStatusNotFound && (
            <Flex mt={2} alignItems="center" justifyContent="space-between">
              <Text fontSize="sm" color="red.500">
                "{tempPdfStatusNotFound}" (do PDF) não encontrado.
              </Text>
              <Button
                size="sm"
                colorScheme="blue"
                onClick={() => {
                  setNewStatusName(tempPdfStatusNotFound);
                  onNewStatusModalOpen();
                }}
              >
                Adicionar como Novo Status
              </Button>
            </Flex>
          )}
        </FormControl>
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Tipo de Serviço</FormLabel>
          <Select
            placeholder="Selecionar serviço"
            {...inputStyles}
            isDisabled={loadingOptions}
            value={tipoServicoSelecionado}
            onChange={(e) => {
              setTipoServicoSelecionado(e.target.value);
              setTempPdfServiceTypeNotFound("");
            }}
          >
            {loadingOptions ? (
              <option>Carregando...</option>
            ) : (
              tiposServico
                .filter((opt) => opt)
                .map((opt) => (
                  <option key={opt.optionsId} value={opt.optionsId}>
                    {opt.description}
                  </option>
                ))
            )}
          </Select>
          {tempPdfServiceTypeNotFound && (
            <Flex mt={2} alignItems="center" justifyContent="space-between">
              <Text fontSize="sm" color="red.500">
                "{tempPdfServiceTypeNotFound}" (do PDF) não encontrado.
              </Text>
              <Button
                size="sm"
                colorScheme="blue"
                onClick={() => {
                  setNewServiceTypeName(tempPdfServiceTypeNotFound);
                  onNewServiceTypeModalOpen();
                }}
              >
                Adicionar como Novo Tipo
              </Button>
            </Flex>
          )}
        </FormControl>
      </Flex>

      <SectionTitle>Datas</SectionTitle>
      <Flex gap={4} mb={4} flexWrap="wrap">
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Data de Abertura</FormLabel>
          <Input
            type="datetime-local"
            {...inputStyles}
            value={dateRequest}
            onChange={(e) => setDateRequest(e.target.value)}
            onBlur={() => {
              const fixed = normalizeDateTimeLocal(dateRequest);
              if (fixed && fixed !== dateRequest) setDateRequest(fixed);
            }}
          />
        </FormControl>
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Início Efetivo</FormLabel>
          <Input
            type="datetime-local"
            {...inputStyles}
            value={dateStart}
            onChange={(e) => setDateStart(e.target.value)}
            onBlur={() => {
              const fixed = normalizeDateTimeLocal(dateStart);
              if (fixed && fixed !== dateStart) setDateStart(fixed);
            }}
          />
        </FormControl>
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Término Previsto (SLA)</FormLabel>
          <Input
            type="datetime-local"
            {...inputStyles}
            value={dateEnd}
            onChange={(e) => setDateEnd(e.target.value)}
            onBlur={() => {
              const fixed = normalizeDateTimeLocal(dateEnd);
              if (fixed && fixed !== dateEnd) setDateEnd(fixed);
            }}
          />
        </FormControl>
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Data de Término Esperado</FormLabel>
          <Input
            type="datetime-local"
            {...inputStyles}
            value={dateExpected}
            onChange={(e) => setDateExpected(e.target.value)}
            onBlur={() => {
              const fixed = normalizeDateTimeLocal(dateExpected);
              if (fixed && fixed !== dateExpected) setDateExpected(fixed);
            }}
          />
        </FormControl>
      </Flex>

      <SectionTitle>Local do Serviço</SectionTitle>
      <FormControl mb={4}>
        <FormLabel>Endereço Completo</FormLabel>
        <Input
          placeholder="Detalhes do endereço "
          {...inputStyles}
          value={endereco}
          onChange={(e) => setEndereco(e.target.value)}
          isReadOnly={unidade !== ""}
        />
      </FormControl>
      <Flex gap={4} mb={4} flexWrap="wrap" alignItems="flex-end">
        <FormControl flex="1" minW="250px" isRequired>
          <FormLabel>Unidade</FormLabel>
          <Select
            placeholder={
              loadingUnits ? "Carregando unidades..." : "Selecione uma Unidade"
            }
            {...inputStyles}
            isDisabled={loadingUnits}
            value={unidade}
            onChange={handleUnitSelect}
          >
            <option value="">Selecione uma Unidade</option>
            {loadingUnits ? (
              <option>Carregando...</option>
            ) : errorUnits ? (
              <option>{errorUnits}</option>
            ) : (
              availableUnits
                .filter((unit) => unit)
                .map((unit) => (
                  <option
                    key={unit.companyAddressId}
                    value={unit.companyAddressId}
                  >
                    {unit.unityName || "[Sem Nome]"}
                  </option>
                ))
            )}
          </Select>
          {tempPdfUnitNotFound && (
            <Flex
              mt={2}
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Text fontSize="sm" color="red.500" flex="1" mr={2}>
                "{tempPdfUnitNotFound}" (do PDF) não encontrada.
              </Text>
              <Button
                size="sm"
                colorScheme="blue"
                onClick={() => {
                  setNovaFilialForm((prev) => ({
                    ...prev,
                    unityName:
                      tempPdfUnitNotFound !==
                      "Não extraído (verificar formato do PDF)"
                        ? tempPdfUnitNotFound
                        : "",
                    additionalAddressDetails: "",
                    additionalAddressDetails2: "",
                    floor: "",
                  }));
                  onOpen();
                }}
                leftIcon={<FiPlusCircle />}
              >
                Adicionar como Nova Unidade
              </Button>
            </Flex>
          )}
        </FormControl>
        <FormControl flex="1" minW="250px">
          <FormLabel>Andar</FormLabel>
          <Input
            placeholder="Andar (Se aplicável)"
            {...inputStyles}
            value={andar}
            onChange={(e) => setAndar(e.target.value)}
          />
        </FormControl>
        <FormControl flex="1" minW="250px">
          <FormLabel>Complemento 1</FormLabel>
          <Input
            placeholder="Ex: Sala, Bloco"
            {...inputStyles}
            value={complemento1}
            onChange={(e) => setComplemento1(e.target.value)}
          />
        </FormControl>
        <FormControl flex="1" minW="250px">
          <FormLabel>Complemento 2</FormLabel>
          <Input
            placeholder="Ex: Próximo à portaria"
            {...inputStyles}
            value={complemento2}
            onChange={(e) => setComplemento2(e.target.value)}
          />
        </FormControl>
      </Flex>

      <SectionTitle>Detalhes da Solicitação</SectionTitle>
      <FormControl mb={4}>
        <FormLabel>Resumo</FormLabel>
        <Input
          placeholder="Resumo breve do serviço"
          {...inputStyles}
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
        />
      </FormControl>
      <FormControl mb={4} isRequired>
        <FormLabel>Detalhes Completos</FormLabel>
        <Textarea
          placeholder="Descreva detalhadamente o problema ou a solicitação..."
          rows={5}
          {...inputStyles}
          value={details}
          onChange={(e) => setDetails(e.target.value)}
        />
      </FormControl>

      <Flex justifyContent="center" mt={8}>
        <Button
          {...ui.primaryButton}
          px={10}
          py={6}
          fontSize="xl"
          borderRadius={modern ? "full" : "md"}
          onClick={handleSubmit}
        >
          Criar Ordem de Serviço
        </Button>
      </Flex>

      {/* Modal para Cadastro de Nova Filial/Unidade */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#C1272D">
            Cadastrar Nova Unidade/Filial
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>Empresa</FormLabel>
              <Select
                placeholder={
                  loadingEmpresas
                    ? "Carregando empresas..."
                    : "Selecione uma Empresa"
                }
                name="empresaId"
                value={novaFilialForm.empresaId}
                onChange={handleChangeNovaFilial}
                bg="white"
                borderColor="#625752"
                focusBorderColor="#C1272D"
                isDisabled={loadingEmpresas}
              >
                {loadingEmpresas ? (
                  <option>Carregando...</option>
                ) : errorEmpresas ? (
                  <option>{errorEmpresas}</option>
                ) : (
                  empresasOptions
                    .filter((opt) => opt)
                    .map((empresa) => (
                      <option key={empresa.optionsId} value={empresa.optionsId}>
                        {empresa.description}
                      </option>
                    ))
                )}
              </Select>
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>Nome da Unidade/Filial</FormLabel>
              <Input
                placeholder="Ex: Matriz São Paulo"
                name="unityName"
                value={novaFilialForm.unityName}
                onChange={handleChangeNovaFilial}
                bg="white"
                borderColor="#625752"
                focusBorderColor="#C1272D"
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel display="flex" alignItems="center" gap={2}>
                Endereço Principal
              </FormLabel>
              <Input
                placeholder="Ex: Rua Exemplo, 123 - Bairro"
                name="endereco"
                value={endereco}
                onChange={(e) => setEndereco(e.target.value)}
                bg="white"
                borderColor="#625752"
                focusBorderColor="#C1272D"
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bg="#C1272D"
              color="white"
              _hover={{ bg: "#a81f23" }}
              px={8}
              mr={3}
              onClick={handleSubmitNovaFilial}
            >
              Cadastrar Unidade
            </Button>
            <Button
              variant="outline"
              borderColor="#625752"
              color="#625752"
              _hover={{ bg: "#f4f4f4" }}
              px={8}
              onClick={() => {
                setNovaFilialForm({
                  empresaId: "",
                  unityName: "",
                  additionalAddressDetails: "",
                  // additionalAddressDetails2: "",
                  // floor: "",
                });
                onClose();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para Novo Tipo de Serviço */}
      <Modal
        isOpen={isNewServiceTypeModalOpen}
        onClose={onNewServiceTypeModalClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#C1272D">
            Adicionar Novo Tipo de Serviço
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4} isRequired>
              <FormLabel>Nome do Tipo de Serviço</FormLabel>
              <Input
                placeholder="Ex: Hidráulica - Reparos de rede"
                value={newServiceTypeName}
                onChange={(e) => setNewServiceTypeName(e.target.value)}
                bg="white"
                borderColor="#625752"
                focusBorderColor="#C1272D"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#C1272D"
              color="white"
              _hover={{ bg: "#a81f23" }}
              px={8}
              mr={3}
              onClick={handleAddServiceType}
            >
              Adicionar
            </Button>
            <Button
              variant="outline"
              borderColor="#625752"
              color="#625752"
              _hover={{ bg: "#f4f4f4" }}
              px={8}
              onClick={() => {
                setNewServiceTypeName("");
                onNewServiceTypeModalClose();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para Novo Tipo de Equipe */}
      <Modal isOpen={isNewTeamTypeModal} onClose={onNewTeamTypeModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#C1272D">
            Adicionar Novo Tipo de Equipe
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4} isRequired>
              <FormLabel>Nome do Tipo de Equipe</FormLabel>
              <Input
                placeholder="Ex: Manutenção Elétrica"
                value={newTeamTypeName}
                onChange={(e) => setNewTeamTypeName(e.target.value)}
                bg="white"
                borderColor="#625752"
                focusBorderColor="#C1272D"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#C1272D"
              color="white"
              _hover={{ bg: "#a81f23" }}
              px={8}
              mr={3}
              onClick={handleAddTeamType}
            >
              Adicionar
            </Button>
            <Button
              variant="outline"
              borderColor="#625752"
              color="#625752"
              _hover={{ bg: "#f4f4f4" }}
              px={8}
              onClick={() => {
                setNewTeamTypeName("");
                onNewTeamTypeModalClose();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para Nova Prioridade */}
      <Modal isOpen={isNewPriorityModalOpen} onClose={onNewPriorityModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#C1272D">Adicionar Nova Prioridade</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4} isRequired>
              <FormLabel>Nome da Prioridade</FormLabel>
              <Input
                placeholder="Ex: Urgente"
                value={newPriorityName}
                onChange={(e) => setNewPriorityName(e.target.value)}
                bg="white"
                borderColor="#625752"
                focusBorderColor="#C1272D"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#C1272D"
              color="white"
              _hover={{ bg: "#a81f23" }}
              px={8}
              mr={3}
              onClick={handleAddPriority}
            >
              Adicionar
            </Button>
            <Button
              variant="outline"
              borderColor="#625752"
              color="#625752"
              _hover={{ bg: "#f4f4f4" }}
              px={8}
              onClick={() => {
                setNewPriorityName("");
                onNewPriorityModalClose();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para Novo Status */}
      <Modal isOpen={isNewStatusModalOpen} onClose={onNewStatusModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#C1272D">Adicionar Novo Status</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4} isRequired>
              <FormLabel>Nome do Status</FormLabel>
              <Input
                placeholder="Ex: Em Andamento"
                value={newStatusName}
                onChange={(e) => setNewStatusName(e.target.value)}
                bg="white"
                borderColor="#625752"
                focusBorderColor="#C1272D"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#C1272D"
              color="white"
              _hover={{ bg: "#a81f23" }}
              px={8}
              mr={3}
              onClick={handleAddStatus}
            >
              Adicionar
            </Button>
            <Button
              variant="outline"
              borderColor="#625752"
              color="#625752"
              _hover={{ bg: "#f4f4f4" }}
              px={8}
              onClick={() => {
                setNewStatusName("");
                onNewStatusModalClose();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );

  if (modern) {
    return (
      <ModernPageShell
        title="Criar ordem de serviço"
        subtitle="Preencha os dados manualmente ou importe um PDF do chamado para agilizar o cadastro."
        eyebrow="Atendimentos"
      >
        <Box maxW="1000px" {...ui.panel} p={{ base: 5, md: 8 }}>
          {pageContent}
        </Box>
      </ModernPageShell>
    );
  }

  return (
    <Box
      maxW="1000px"
      mx="auto"
      mt={10}
      p={10}
      bg="white"
      borderRadius="2xl"
      boxShadow="lg"
      border="1px solid"
      borderColor="#DDD"
    >
      {pageContent}
    </Box>
  );
}
